import request from '@/utils/request'

/**
 * 获取选项树
 */
export const getOptionTree = (data) => {
    return request({
        url: '/room/option/tree',
        params: data
    })
}

// 获取房间类型+房间树
export const getRoomTypeRoomOptionTree = (data) => {
    return request({
        url: '/room/type/room/option/tree',
        params: data
    })
}

// camera+房间树
export const getCameraRoomOptionTree = (data) => {
    return request({
        url: '/room/camera/option/tree',
        params: data
    })
}

export const getRoomTreeLists = (data) => {
    return request({
        url: '/room/tree',
        params: data
    })
}
